import Utils from '../utils';
import history from './history';
import location from './location';
import queryString from './queryString';
import { REZDY_DOMAIN } from '../constants/auth';

const isRezdyUrl = (url: string) => {
    try {
        const probeUrl = new URL(decodeURIComponent(url));
        if (!probeUrl.hostname.endsWith(REZDY_DOMAIN)) {
            return false;
        }
    } catch (e) {
        // its a relative path
        return true;
    }
    return true;
};

export const push = (route: string, overrideParams?: { [key: string]: string }, replaceParams: boolean = false) => {
    if (!isRezdyUrl(route)) {
        return;
    }
    if (overrideParams) {
        const currentParams = replaceParams ? {} : queryString.parse(location.search);
        const nextParams = {
            ...currentParams,
            ...overrideParams,
        };
        history.push(`${route}?${queryString.stringify(nextParams)}`);
    } else {
        history.push(`${route}${location.search}`);
    }
};

export const reload = () => history.go(0);

export const link = (route: string) => {
    return `${route}${location.search}`;
};

export const redirectUri = () => {
    const params = queryString.parse(location.search);
    const url = Utils.sanitizeUrl(params.redirect_uri);
    if (url) {
        location.href = url;
    }
};

export default {
    history,
    link,
    location,
    push,
    redirectUri,
};
